// extracted by mini-css-extract-plugin
export default {"container":"CardPointSummary_container__5WaJI","wrapperTable":"CardPointSummary_wrapperTable__frRSi","groupText":"CardPointSummary_groupText__YzDPZ"};